import React from 'react';
import { profile } from '@utils/default-values';

import {
  ACTION_VARIANTS,
  Card,
  ICON_NAMES,
  Link,
} from '@reverse-hr/design-system';
import classNames from 'classnames';

const ReferentCard = ({ manager = {}, modifier }) => {
  const { blankReferentCard } = profile();
  const isManager = !!manager?.email;
  const hasPhoneNumber = isManager && !!manager.phoneNumber;
  const jobTitle = isManager ? manager.jobTitle : '';

  const wrapperClassNames = classNames(
    'c-app-card-referent',
    {
      'c-app-card-referent--placeholder': !isManager,
    },
    modifier,
  );

  const avatar =
    isManager && manager.avatarUrl
      ? manager.avatarUrl
      : REFERENT_PLACEHOLDER_AVATAR;

  const fullName = isManager
    ? `${manager.firstName} ${manager.lastName}`
    : blankReferentCard.title;

  const text = blankReferentCard.text;

  return (
    <Card className={wrapperClassNames}>
      <img alt={fullName} className="c-app-card-referent__media" src={avatar} />

      <div className="c-app-card-referent__head">
        <p className="c-app-card-referent__title">{fullName}</p>

        {isManager && (
          <p className="c-app-card-referent__subtitle">{jobTitle}</p>
        )}
      </div>

      {isManager ? (
        <div className="c-app-card-referent__links">
          <Link
            className="c-app-card-referent__link"
            href={`mailto:${manager.email}`}
            leftIcon={ICON_NAMES.MAIL}
            variant={ACTION_VARIANTS.GHOST}
          >
            {manager.email}
          </Link>

          {hasPhoneNumber && (
            <Link
              className="c-app-card-referent__link"
              href={`tel:${manager.phoneNumber}`}
              leftIcon={ICON_NAMES.PHONE_OUTLINE}
              variant={ACTION_VARIANTS.GHOST}
            >
              {manager.phoneNumber}
            </Link>
          )}
        </div>
      ) : (
        <p className="c-app-card-referent__text">{text}</p>
      )}
    </Card>
  );
};

export default ReferentCard;

const REFERENT_PLACEHOLDER_AVATAR = `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/referent-placeholder.png`;
